// fork from RBMC
import logger from '../utils/rbata.logger';

const consumerEvents = {
    trackAddToCartEvent: function (trackingData) {
        window.mediator.publish('trackAddToCart', {
            productCode: trackingData.id,
            quantity:    trackingData.quantity,
            cartData:    {
                cartCode:     trackingData.code,
                categories:   trackingData.categoriesAsJsonString,
                productCode:  trackingData.id,
                productName:  trackingData.name,
                productPrice: trackingData.price,
                quantity:     trackingData.quantity,
                color:        trackingData.color,
                size:         trackingData.size
            }
        });
    },

    trackRemoveFromCartEvent: function (trackingData) {
        window.mediator.publish('trackRemoveFromCart', {
            productCode:         trackingData.id,
            initialCartQuantity: trackingData.quantity
        });
    },

    trackUpdateCartEvent: function (trackingData, initialQuantity, newQuantity) {
        window.mediator.publish('trackUpdateCart', {
            productCode:         trackingData.id,
            initialCartQuantity: initialQuantity,
            newCartQuantity:     newQuantity
        });
    },

    trackBannerClickEvent(componentId) {
        try {
            logger.log('trackBannerClickEvent: ' + componentId);
            window.mediator.publish('trackBannerClick', {
                componentId: componentId
            });
        } catch (e) {
            logger.log('piwik is not present');
        }
    }
};

export default consumerEvents;
